import { useToggle } from '@app/hooks/useToggle'

import { setStorageSideMenu, getSideMenuToggleInitialValue } from './utils'

import type { UseSideMenuReturn } from './types'

const initialValue = getSideMenuToggleInitialValue()

export const useSideMenu = (): UseSideMenuReturn => {
  const sideMenuToggle = useToggle(initialValue)

  const isCollapse = sideMenuToggle.value

  const expandSideMenu = (): void => {
    setStorageSideMenu(false)
    sideMenuToggle.setUntoggled()
  }

  const collapseSideMenu = (): void => {
    setStorageSideMenu(true)
    sideMenuToggle.setToggled()
  }

  const toggleSideMenu = (): void => {
    sideMenuToggle.setValue(prevValue => {
      const newValue = !prevValue
      setStorageSideMenu(newValue)
      return newValue
    })
  }

  return {
    isCollapse,
    expandSideMenu,
    collapseSideMenu,
    toggleSideMenu
  }
}
